/**
 * Vuex store module for Customer Care (Metabase collection) integration.
 *
 * @module store/modules/customercare
 * @description Manages state for Customer Care Metabase dashboards from specific collection.
 * Similar to ecare module but fetches dashboards by collection filter.
 *
 * @example
 * // Access state
 * this.$store.state.customercare.dashboards
 *
 * // Dispatch action
 * this.$store.dispatch('CUSTOMER_CARE_GET_DASHBOARDS')
 *
 * // Toggle editor
 * this.$store.dispatch('CUSTOMER_CARE_TOGGLE_EDITOR_VISIBLE')
 */
import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { CustomerCareState } from "./types";
import { RootState } from "@/store/types";

const customercare: Module<CustomerCareState, RootState> = {
  // namespaced: true,
  actions,
  mutations,
  state,
};

export default customercare;
